export interface CouncilHousingOrganization {
  registration_number: string;
  organisation_name: string;
}

export class CouncilHousingService {
  static async searchCouncilHousing(
    query: string, 
    propertyOwnershipType?: 'council' | 'housing-association' | null
  ): Promise<CouncilHousingOrganization[]> {
    if (query.length < 2) {
      return [];
    }

    try {
      const { supabase } = await import('../lib/supabase');
      
      let queryBuilder = supabase
        .from('council_housing')
        .select('registration_number, organisation_name')
        .ilike('organisation_name', `%${query}%`)
        .order('organisation_name')
        .limit(10);

      // Apply filtering based on property ownership type
      if (propertyOwnershipType === 'council') {
        // For council properties, only show Local Authority organizations
        queryBuilder = queryBuilder.eq('designation', 'Local authority');
      } else if (propertyOwnershipType === 'housing-association') {
        // For housing association properties, exclude Local Authority organizations
        queryBuilder = queryBuilder.neq('designation', 'Local authority');
      }

      const { data, error } = await queryBuilder;

      if (error) {
        console.error('Error searching council housing:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Error in searchCouncilHousing:', error);
      return [];
    }
  }
}